import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { EventTileGroup } from 'components/UI/EventTileGroup/EventTileGroup';
import { EventTile } from 'components/UI/EventTile/EventTile';
import { Link } from 'components/UI/Link/Link';
import { Loading } from 'components/UI/Loading/Loading';
import { whatsOnToday } from 'services/WhatsOnService';
import backgroundImage from 'assets/icons/svgs/spire-pattern.svg';
import { whatsOnTodayParams } from './whats-on-today-utils';

import './WhatsOnToday.scss';

export const WhatsOnToday = (props) => {
  const { sectionTitle, sectionLink } = props;
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const classes = ['whats-on-today', isLoading ? 'whats-on-today--is-loading' : ''].join(' ');

  const fetchEvents = async () => {
    setIsLoading(true);
    try {
      const response = await whatsOnToday(whatsOnTodayParams);

      setEvents(response.events);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error(e);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const whatsOnTodayContent =
    events.length > 0 ? (
      <section
        className={classes}
        data-testid="whats-on-today"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="whats-on-today__container container">
          <h2 className="whats-on-today__heading h3">{sectionTitle}</h2>
          <Link
            extendClass="whats-on-today__link"
            chevron
            variant="secondary"
            href={sectionLink?.key}
          >
            {sectionLink?.name}
          </Link>
          <EventTileGroup>
            {events?.map((event, index) => (
              <EventTile {...event} key={index} />
            ))}
          </EventTileGroup>
        </div>
      </section>
    ) : null;

  return isLoading ? (
    <section className={classes} style={{ backgroundImage: `url(${backgroundImage})` }}>
      <Loading />
    </section>
  ) : (
    whatsOnTodayContent
  );
};

export const WhatsOnTodaySC = (props) => {
  const { sitecoreData } = props;
  return <WhatsOnToday {...sitecoreData} />;
};

WhatsOnToday.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  sectionLink: PropTypes.object,
};

WhatsOnTodaySC.propTypes = {
  sitecoreData: PropTypes.object,
};
